import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { FormRegistrationFormView } from './form-registration-form.presentation';
import FormRegistrationFormVM from './form-registration-form.viewmodel';

export interface IGeneralRegistrationContainerProps {
    accountId: number;
    eventId: number;
    subdomain: string;
    closeConfigureRegistrationForm: () => void;
}

const RegistrationFormContainer = withViewModel(FormRegistrationFormView,
    async (props: IGeneralRegistrationContainerProps) => {
    const { accountId, eventId, subdomain, closeConfigureRegistrationForm } = props;
    const formRegistrationVM = new FormRegistrationFormVM(
        accountId,
        eventId,
        subdomain,
        closeConfigureRegistrationForm,
    );

    formRegistrationVM.initialize();

    return formRegistrationVM;
});

export { RegistrationFormContainer as FormRegistrationForm };